class PdpAddOnProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.renderedVariantId = this.getAttribute("rendered-variant-id");

    this.addEventListener("variant:changed", (e) => {
      const { variant } = e.detail;
      this.updateContent(variant);
    });
  }

  disconnectedCallback() {}

  updateContent(variant) {
    if (!variant || this.renderedVariantId === variant.id) return;

    this.titleEls.forEach((titleEl) => {
      titleEl.innerHTML = variant.product.title;
    });

    this.priceEls.forEach((priceEl) => {
      priceEl.setAttribute("price", variant.price.amount);
      priceEl.setAttribute("compare-at-price", variant.compareAtPrice?.amount);
      priceEl.setAttribute("currency", variant.price.currencyCode);
      priceEl.setAttribute("dynamic", "");
    });

    this.imageEls.forEach((imageEl) => {
      if (variant.image) {
        imageEl.style.display = null;
        imageEl.alt =
          variant.image.altText || `${variant.product.title} ${variant.title}`;
        imageEl.srcset = window.getSizedImageUrl(variant.image.url, "x600");
      } else {
        imageEl.style.display = "none";
      }
    });

    this.stockStatusEls.forEach((stockStatusEl) => {
      stockStatusEl.setAttribute("variant-id", variant.id);
    });

    this.renderedVariantId = variant.id;
  }

  get titleEls() {
    return this.querySelectorAll("[data-product-title]");
  }

  get priceEls() {
    return this.querySelectorAll("price-snippet");
  }

  get imageEls() {
    return this.querySelectorAll(".pdp-add-on-products__image");
  }

  get stockStatusEls() {
    return this.querySelectorAll("stock-status");
  }
}

if (!customElements.get("pdp-add-on-products")) {
  customElements.define("pdp-add-on-products", PdpAddOnProducts);
}
